import React, {Component} from 'react';
import { RevList, RevHeader, RevNodeContainer, RevNode1, RevNode2, Arrow, ViewMore} from '../styles/review_panel_styles.js';
import ReviewItem from '../container/review_item.js';
import {trackPromise} from 'react-promise-tracker';

const underlinedBlue = {textDecorationLine: 'underline', color: "#6ec1e4" }

const noMoreReviews = { color: "red"}

const DEMO_API = process.env.REACT_APP_API

export default class ReviewsContainer extends Component {
  constructor(props){
    super()
    this.state ={
      summary: props.summary,
      selection: props.selection,
      load_more_clicked: props.load_more_clicked
      }
      this.highlight = this.highlight.bind(this);
      this.fetchMoreReviews = this.fetchMoreReviews.bind(this);
    }

  UNSAFE_componentWillReceiveProps(props){
    if(props.selection && (props.selection !== this.state.selection)){
      this.setState({
        summary: props.summary,
        selection: {
          type: props.selection.type,
          object: props.selection.object
        },
        load_more_clicked: false,
        reviews: null
      })
    }
  }

  nodeFinder(id){
    var data = this.props.summary.nodes
    var selected_node
    for(var node of data){
      if(node.id === id){
        selected_node = node
        return selected_node
      }
    }
  }

  reviewCount(revs){
    var count = 0
    revs.forEach(function(rev){
      count++
    })
    return count
  }

  setNodeSection(){
    if(this.state.selection.object){
      const object = this.state.selection.object
      const selection = this.state.selection
      let review_count = 0
      const ArrowIcon = require("../images/long-arrow-left-100.png")
      if(selection.type === "link"){
        let target_node = this.nodeFinder(object.target.id)
        let source_node = this.nodeFinder(object.source.id)
        if(this.state.reviews){
          review_count = this.reviewCount(this.state.reviews)
        }
        else {
          review_count = this.reviewCount(object.reviews)
        }
        let rev_head = (review_count === 1) ? "Review" : "Reviews"
        return(
          <div>
          <RevHeader> {review_count} {rev_head} for: </RevHeader>
          <RevNodeContainer>
            <RevNode1 attrColor={object.target.color_code}> {target_node.title}  </RevNode1>
            <Arrow src={ArrowIcon} alt="from arrow"/>
            <RevNode2 attrColor={object.source.color_code}> {source_node.title} </RevNode2>
          </RevNodeContainer>
          </div>
        )
      }
      if(selection.type === "node"){
        if(this.state.reviews){
          review_count = this.reviewCount(this.state.reviews)
        }
        else {
          review_count = this.reviewCount(object.reviews)
        }

        let rev_head = (review_count === 1) ? "Review" : "Reviews"

        return(
          <div>
          <RevHeader> {review_count} {rev_head} for: </RevHeader>
          <RevNodeContainer>
            <RevNode1 attrColor= {object.color_code}> {object.title} </RevNode1>
          </RevNodeContainer>
          </div>
        )
        }
      }
      return (<div> "Here go the reviews related to your search, click on a node or edge to get more." </div>)
    }

  renderReviews(){
    if(this.state.selection.object){
      var source_node
      if(this.state.selection.type === "node"){
        source_node = this.nodeFinder(this.state.selection.object.id)
      } else {
        source_node = this.nodeFinder(this.state.selection.object.source.id)
      }
      var color_code = source_node.color_code
      var reviews = this.state.reviews ? this.state.reviews : this.state.selection.object.reviews
      //place reviews
      var revItems = reviews.map((rev, ndx) => {

        let regexes = rev.highlight.map(word => new RegExp(`\\b${word}\\b`, 'ig'));
        let full_rev = this.highlight(rev.full, regexes, color_code)
        let short_rev = this.highlight(rev.short, regexes, color_code)

        return(
          <ReviewItem
          review={rev}
          full = {full_rev}
          short = {short_rev}
          key={ndx}
          ndx = {ndx}
          />
          )
        })
    return revItems
    }
  }

  highlight(review, regexes, color_code) {
    let color_tag = {color: color_code}

    if (!regexes.length) {
       return review;
    }

    let split = review.split(regexes[0]);
    let replacements = review.match(regexes[0]);
    let result = [];
    for (let i = 0; i < split.length - 1; i++) {
      result.push(this.highlight(split[i], regexes.slice(1), color_code));
      result.push(<span style={color_tag} key={i}>{replacements[i]}</span>);
    }
    result.push(this.highlight(split[split.length - 1], regexes.slice(1), color_code));
    return result;
  }

  onSeeMoreClick(){
    var nodeID;
    var target;
    if(this.state.selection){
      if(this.state.selection.type === "link"){
        nodeID = this.state.selection.object.source
        target = this.state.selection.object.target
      }
      if(this.state.selection.type === "node"){
        nodeID = this.state.selection.object.id
        target = "None"
      }
      this.fetchMoreReviews(nodeID, target)
    }
  }

  fetchMoreReviews(nodeID, target){
    var node_encoded = encodeURIComponent(JSON.stringify(nodeID))
    var id="770934d2-4309-4cf0-9ec6-21b312144de6"
    trackPromise(
    fetch(`${DEMO_API}/load_review/?id=` + id + '&node_id=' + node_encoded + '&target_id=' + target,
    {
      method: 'GET'
    })
    .then(res => res.json())
    .then((data) => {
      this.setState({
        reviews: data.reviews,
        load_more_clicked: true
      }
    )
    })
    .catch(console.log)
    )
  }

  toTop(){

  }

  conditionalViewMore(){
    if(!this.state.load_more_clicked){
      return(
        <ViewMore onClick={() => this.onSeeMoreClick()}>
          <span style={underlinedBlue}> LOAD MORE » </span>
        </ViewMore>
      )
    } else {
      return(
        <ViewMore>
          <span style={noMoreReviews}> End of Reviews</span>
        </ViewMore>
      )
    }
  }

    render(){

      return (
        <div style={{height: "700px", overflowY: "scroll"}}>
          { this.setNodeSection() }
          <RevList>
          { this.renderReviews() }
          </RevList>
          { this.conditionalViewMore() }
        </div>
      )
    }

}
